import { notification } from "antd";
import store from "../../store/store";
import { appendToGridData, removeSingleLoadKey, resetReportState, setAudienceSpecificCategoriesData, setCategoryDeepDiveData, setGeneralMarketCategoriesData, setGenerateGridData, setNewItemInCategoryDeepDive, setReportIsLoading, updateItemInCategoryDeepDive } from "../../store/components/Reports.slice";
import ReportsServices from "../../services/Reports.services";
import { setReportBuilderMode } from "../../store/components/ReportBuilder.slice";
import WhiteSpaceServices from "../../services/WhiteSpace.services";
import { resetInsightsState } from "../../store/components/Insights.slice";
import getState, { createPromise } from "../MainHelper";
import TrackFeatureServices from "../../services/TrackFeature.services";
import { getSelectedAnalysis } from "../oneintelligence/OneIntelligenceHelper";
import ConfigServices from "../../services/Config.services";

export const loadFullMarketReports = async () => {
    const { dispatch } = store;
    dispatch(setReportIsLoading(true));
    dispatch(resetReportState(true));
    dispatch(resetInsightsState());

    const { commonParams } = TrackFeatureServices.getMonitor({ featureKey: "advanceRunFullMarkerAnalysis" })

    await ReportsServices.getSSPGetAudienceSize(commonParams);
    const { promise } = ReportsServices.getUsigDashboard(commonParams);
    promise.then((response) => {
        if (!response.generalData && !response.specificData && !response.deepDiveData) {
            dispatch(setReportBuilderMode("select"));
        } else {
            dispatch(setGeneralMarketCategoriesData(response.generalData || []));
            dispatch(setAudienceSpecificCategoriesData(response.specificData || []));
            dispatch(setCategoryDeepDiveData(response.deepDiveData || []));
        }
        dispatch(setReportIsLoading(false));
    });
};
export const loadSingleCategoryReports = async (main = true, featureKey) => {
    const { dispatch } = store;
    if (main) {
        await dispatch(setReportIsLoading(true));
        await dispatch(resetReportState(true));
        await dispatch(resetInsightsState());
    } else {
        // await dispatch(setReportIsLoading(true));
    }
    // await ReportsServices.getSSPGetAudienceSize();
    const { commonParams } = TrackFeatureServices.getMonitor({ featureKey: featureKey || "advanceRunPrebuilt" })
    const { promise } = ReportsServices.getQuickReports(commonParams, () => ReportsServices.getSSPGetAudienceSize(commonParams));
    promise.then((response) => {
        if (main) {
            if (response?.length) {
                dispatch(setCategoryDeepDiveData(response));
            }
        } else {
            dispatch(setNewItemInCategoryDeepDive(response?.length ? response : []));
        }
        dispatch(setReportIsLoading(false));
    });
};

export const loadMarketCategoryReports = async (main = false, allTreeData, percentCallback = () => { }, monitorObj) => {
    const { dispatch } = store;
    if (main) {
        dispatch(setReportIsLoading(true));
        dispatch(resetReportState(true));
        dispatch(resetInsightsState());
    }
    // await ReportsServices.getSSPGetAudienceSize();
    const { commonParams } = TrackFeatureServices.getMonitor(monitorObj ? monitorObj : { featureKey: "advanceRunCategoryAnalysis" })
    ReportsServices.addBehaviouralSegmentFolder(allTreeData, main, (newItems) => {
        dispatch(setNewItemInCategoryDeepDive(newItems));
    }, (groupData, childList) => {
        dispatch(updateItemInCategoryDeepDive({ groupData, children: childList }));
    }, () => Promise.all([ReportsServices.getSSPGetAudienceSize(commonParams), ConfigServices.getHardCodedSize()])
        , percentCallback, undefined, commonParams).then(() => {
            if (main) {
                dispatch(setReportIsLoading(false));
            }
            dispatch(removeSingleLoadKey());
        });
};

export const loadMarketCategoryReportsNotInState = async (main = false, allTreeData, percentCallback = () => { }, givenBuildedTargets) => {
    let tempList = [];
    const setNewGroup = (newItems) => {
        let lastGroup = 0;
        if (tempList.length) {
            const groups = tempList.map((c) => c.group);
            lastGroup = Math.max(...groups);
        }
        newItems.forEach((newGroup) => {
            lastGroup += 1;
            tempList.push({
                ...newGroup,
                group: lastGroup
            });
        });
    }
    const updateGroup = (groupData, children) => {
        const groupIdx = groupData.group - 1;
        const findData = tempList[groupIdx];
        if (findData) {
            if (findData.loading) findData.loading = false;
            if (groupData.singleLoad) findData.singleLoad = groupData.singleLoad;
            findData.children = children;
            findData.discoveredCategory = groupData.discoveredCategory;
        }
    }
    const removeSingleLoadKey = (tempList) => tempList.map((item) => {
        const newItem = { ...item };
        delete newItem.singleLoad;
        delete newItem.loading;
        return newItem;
    });
    const { promise, resolve } = createPromise()
    ReportsServices.addBehaviouralSegmentFolder(allTreeData, main, setNewGroup, updateGroup,
        () => ReportsServices.getSSPGetAudienceSize()
        , percentCallback, givenBuildedTargets).then(() => {
            resolve(removeSingleLoadKey(tempList));
        });
    return promise
};

export const loadFreeFormReports = async (main = false) => {
    const state = getState();;
    const { exactTerm } = state.reports;
    const { dispatch } = store;

    const initialCallBack = (newItems) => {
        dispatch(setNewItemInCategoryDeepDive(newItems));
    };
    const doneApiCallBack = (groupData, children) => {
        dispatch(updateItemInCategoryDeepDive({ groupData, children }));
    };
    if (main) {
        await dispatch(setReportIsLoading(true));
        await dispatch(resetReportState(true));
        await dispatch(resetInsightsState());
    }
    const doneLoadingReports = () => {
        if (main) {
            dispatch(setReportIsLoading(false));
        }
        dispatch(removeSingleLoadKey());
    };
    const { commonParams } = TrackFeatureServices.getMonitor({ featureKey: "advanceRunOpenAnalysis" })
    // await ReportsServices.getSSPGetAudienceSize();
    const waitFunction = () => ReportsServices.getSSPGetAudienceSize(commonParams);
    if (exactTerm) {
        console.log("Loading freeform exact");
        ReportsServices.getFreeFormExact(main, initialCallBack, doneApiCallBack, waitFunction, commonParams).promise.then(() => {
            console.log("Done loading freeform exact");
            doneLoadingReports();
        });
    } else {
        console.log("Loading freeform not exact");
        ReportsServices.getFreeFormNotExact(main, initialCallBack, doneApiCallBack, waitFunction, commonParams).then(() => {
            console.log("Done loading freeform not exact");
            doneLoadingReports();
        });
    }
};

export const loadGenerateGrid = async (main = false, isAppend) => {
    const { dispatch } = store;
    await dispatch(setReportIsLoading(true));
    if (main) {
        await dispatch(resetReportState(true));
        await dispatch(resetInsightsState());
    }
    const doneLoadingReports = () => {
        dispatch(setReportIsLoading(false));
    };
    const current = getSelectedAnalysis();
    let featureName = "";
    if (current) {
        if (isAppend) {
            featureName = "Whitespace/Append New " + current.name
        } else {
            featureName = "Whitespace/Run " + current.name
        }
    } else {
        if (isAppend) {
            featureName = "Whitespace/Append New Report"
        } else {
            featureName = "Whitespace/Run Report"
        }
    }
    const { commonParams } = TrackFeatureServices.getMonitor({ featureName })
    await WhiteSpaceServices.getSSPAudienceSizeForWhiteSpace(commonParams);
    await ConfigServices.getHardCodedSize();
    const reponse = await WhiteSpaceServices.getWhiteSpace(commonParams);
    // const reponse = await WhiteSpaceServices.getWhiteSpaceV2();
    if (reponse.countryloading) {
        dispatch(setReportBuilderMode("select"));
        notification.destroy("reportsnotif");
        return;
    }
    if (isAppend) {
        if (!reponse.length) {
            console.log("Already in reports");
        }
        dispatch(appendToGridData(reponse));
    } else { dispatch(setGenerateGridData(reponse)); }
    doneLoadingReports();
};
